export default __webpack_public_path__ + "static/media/guide.5bb1275d.png";